<template>
  <div>
    <ModalComponent
      name="create-approach"
      height="auto"
      :adaptive="true"
      :scrollable="true"
      :click-to-close="false"
    >
      <form
        class="p-6"
        @submit.prevent="saveApproach"
      >
        <div class="flex items-center justify-between">
          <h3 class="text-lg font-semibold text-primary lg:text-xl">
            Boundary Approaches
          </h3>
        </div>
        <p class="mb-6 mt-1.5 text-sm text-primary/50">
          Select your preferred organizational boundary setting approach
        </p>
        <div class="mt-12 flex flex-col gap-4">
          <BorderedRadioButtonWithInfo
            val="operational_control"
            :model-val="setting"
            radio-name="approach_control"
            radio-text="Operational Control"
            info="This approach reports 100% of the emissions from sources that the organization fully controls through operational policies and authority."
            @checked="setting = 'operational_control'"
          />
          <BorderedRadioButtonWithInfo
            val="financial_control"
            :model-val="setting"
            radio-name="approach_control"
            radio-text="Financial Control"
            info="This approach reports 100% of the emissions when the organization can steer financial and operational policies to gain economic benefits from the activities. However, for specific cases like joint ventures with shared financial control among partners, emissions are computed using the equity share approach. Financial control can be present with less than 50% equity ownership."
            @checked="setting = 'financial_control'"
          />
          <BorderedRadioButtonWithInfo
            val="equity_share"
            :model-val="setting"
            radio-name="approach_control"
            radio-text="Equity Share"
            info="This approach accounts emissions from operations and assets according to its share of equity in the operation. If you own 10% share of the company, you only report 10% of the company’s emission."
            @checked="setting = 'equity_share'"
          />
        </div>
        <div class="mt-6 flex justify-end">
          <PrimaryButton
            type="submit"
            aria-label="Save"
          >
            Continue
          </PrimaryButton>
        </div>
      </form>
    </ModalComponent>
  </div>
</template>

<script>
export default {
  name: 'ConsolidationApproachSelectionModal',

  emits: ['approachSelected'],

  data() {
    return {
      setting: '',
      cantSaveProject: false,
    }
  },

  mounted() {
    this.$modal.show('create-approach')
  },

  methods: {
    saveApproach() {
      this.$modal.hide('create-approach')
      this.$emit('approachSelected', this.setting)
    },
  },
}
</script>
